module.exports = __webpack_public_path__ + "assets/img/logo.c8a7af53.jpg";